import React from 'react'
import { CircularProgress } from '@material-ui/core'
import { Page, Header } from 'components'
import useRouter from 'utils/useRouter'
import { Formulario } from './components/Formulario'
import { useGuardarVestigio } from './hooks/useGuardarVestigio'
import useStyles from './GuardarVestigio.styles'

export const GuardarVestigio = (props) => {
  const { route } = props
  const classes = useStyles()
  const router = useRouter()
  const { vestigio, carregando, isProcessando, handleConfirmGuardarVestigio, handleCancelar } = useGuardarVestigio()

  return (
    <Page className={classes.root} title={`${route.secao} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} pathname={router.location.pathname} router={router} />
      {carregando ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Formulario
          className={classes.aboutProject}
          vestigio={vestigio}
          isProcessando={isProcessando}
          onConfirm={handleConfirmGuardarVestigio}
          onCancel={handleCancelar}
        />
      )}
    </Page>
  )
}


